import { toDate as e } from "./toDate.js";
function u(t) {
  return e(t).getMinutes();
}
export {
  u as default,
  u as getMinutes
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getMinutes.js
// module id = 885
// module chunks = 67